import React from 'react';

const GisZhkkhNotice = ({ children, icon, className = '' }) => (
  <div className={`flex items-start gap-2 rounded-2xl bg-orange-50 px-3 py-2 text-sm text-gray-700 ${className}`}>
    {icon}
    <p>{children}</p>
  </div>
);

export default GisZhkkhNotice;
